/**
 * sort-oos-last.js — ITA2-812 interim
 * Moves out-of-stock product cards to the end of the PLP grid (per loaded page).
 * Hook: MutationObserver on #ProductGridContainer to re-run after AJAX sort/filter
 * (facets.js) and load-more appends. Updates data-product-index post-reorder so the
 * ticker positioner finds the correct card by visual position.
 *
 * Failure mode: if anything throws, the grid renders in its original (unsorted)
 * order. No regression vs. baseline.
 */
(function () {
	'use strict';

	var REORDER_DEBOUNCE_MS = 50;
	var debounceTimer = null;
	var isReordering = false;

	function reorder() {
		if (isReordering) return;
		var grid = document.getElementById('product-grid');
		if (!grid || grid.tagName !== 'UL') return;

		var cards = [];
		for (var i = 0; i < grid.children.length; i++) {
			var child = grid.children[i];
			if (child.dataset && child.dataset.productAvailable !== undefined) {
				cards.push(child);
			}
		}
		if (cards.length === 0) return;

		// Already sorted? (no available card appears after any unavailable card)
		var seenUnavailable = false;
		var alreadySorted = true;
		for (var j = 0; j < cards.length; j++) {
			var avail = cards[j].dataset.productAvailable === 'true';
			if (!avail) {
				seenUnavailable = true;
			} else if (seenUnavailable) {
				alreadySorted = false;
				break;
			}
		}
		if (alreadySorted) return;

		isReordering = true;
		try {
			// Stable partition: in-stock first, OOS last, preserving relative order within each.
			var unavailable = cards.filter(function (c) {
				return c.dataset.productAvailable !== 'true';
			});
			for (var k = 0; k < unavailable.length; k++) {
				grid.appendChild(unavailable[k]);
			}

			// Re-index data-product-index so the ticker positioner finds the correct card.
			var indexed = grid.querySelectorAll(':scope > li.collection-grid-card[data-product-index]');
			for (var m = 0; m < indexed.length; m++) {
				indexed[m].dataset.productIndex = m + 1;
			}

			// Re-fire ticker repositioning (existing inline script listens for this event).
			document.dispatchEvent(new CustomEvent('facets:updated'));
		} finally {
			isReordering = false;
		}
	}

	function debouncedReorder() {
		if (isReordering) return;
		if (debounceTimer) clearTimeout(debounceTimer);
		debounceTimer = setTimeout(reorder, REORDER_DEBOUNCE_MS);
	}

	function init() {
		var container = document.getElementById('ProductGridContainer');
		if (!container) return;

		reorder();

		var observer = new MutationObserver(debouncedReorder);
		observer.observe(container, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
